// All 192 UPU member countries
export const COUNTRIES = [
  "Afghanistan","Albania","Algeria","Angola","Antigua and Barbuda","Argentina","Armenia","Aruba, Curaçao and Sint Maarten","Australia","Austria","Azerbaijan",
  "Bahamas","Bahrain","Bangladesh","Barbados","Belarus","Belgium","Belize","Benin","Bhutan","Bolivia","Bosnia and Herzegovina","Botswana","Brazil","Brunei Darussalam","Bulgaria","Burkina Faso","Burundi",
  "Cabo Verde","Cambodia","Cameroon","Canada","Central African Republic","Chad","Chile","China","Colombia","Comoros","Congo","Costa Rica","Côte d'Ivoire","Croatia","Cuba","Cyprus","Czechia",
  "Dem. People's Rep. of Korea","Dem. Rep. of the Congo","Denmark","Djibouti","Dominica","Dominican Republic",
  "Ecuador","Egypt","El Salvador","Equatorial Guinea","Eritrea","Estonia","Eswatini","Ethiopia",
  "Fiji","Finland","France",
  "Gabon","Gambia","Georgia","Germany","Ghana","Greece","Grenada","Guatemala","Guinea","Guinea-Bissau","Guyana",
  "Haiti","Honduras","Hungary",
  "Iceland","India","Indonesia","Iran","Iraq","Ireland","Israel","Italy",
  "Jamaica","Japan","Jordan",
  "Kazakhstan","Kenya","Kiribati","Kuwait","Kyrgyzstan",
  "Lao People's Dem. Rep.","Latvia","Lebanon","Lesotho","Liberia","Libya","Liechtenstein","Lithuania","Luxembourg",
  "Madagascar","Malawi","Malaysia","Maldives","Mali","Malta","Mauritania","Mauritius","Mexico","Monaco","Mongolia","Montenegro","Morocco","Mozambique","Myanmar",
  "Namibia","Nauru","Nepal","Netherlands","New Zealand","Nicaragua","Niger","Nigeria","North Macedonia","Norway",
  "Oman",
  "Pakistan","Palau","Panama","Papua New Guinea","Paraguay","Peru","Philippines","Poland","Portugal",
  "Qatar",
  "Republic of Korea","Republic of Moldova","Romania","Russian Federation","Rwanda",
  "Saint Kitts and Nevis","Saint Lucia","Saint Vincent and the Grenadines","Samoa","San Marino","Sao Tome and Principe","Saudi Arabia","Senegal","Serbia","Seychelles","Sierra Leone","Singapore","Slovakia","Slovenia","Solomon Islands","Somalia","South Africa","South Sudan","Spain","Sri Lanka","Sudan","Suriname","Sweden","Switzerland","Syrian Arab Republic",
  "Tajikistan","Tanzania","Thailand","Timor-Leste","Togo","Tonga","Trinidad and Tobago","Tunisia","Türkiye","Turkmenistan","Tuvalu",
  "Uganda","Ukraine","United Arab Emirates","United Kingdom","United States of America","Uruguay","Uzbekistan",
  "Vanuatu","Vatican","Venezuela","Viet Nam",
  "Yemen",
  "Zambia","Zimbabwe"
];

export const CURRENCIES = ["USD","EUR","GBP","CHF","INR","JPY","CNY","AUD","CAD","BRL","ZAR","NGN","KES","AED","SAR","SGD","XOF","SDR"];

export const TENDER_TYPES = [
  { value: "RFP", label: "RFP — Request for Proposal" },
  { value: "NIT", label: "NIT — Notice Inviting Tender" },
  { value: "EOI", label: "EOI — Expression of Interest" },
  { value: "RFQ", label: "RFQ — Request for Quotation" },
  { value: "ITB", label: "ITB — Invitation to Bid" },
];

export const CATEGORIES = ["Goods", "Services", "Works", "Consultancy"];

export const UNIT_TYPES = ["Operative Unit", "Administrative Unit", "Training Centre", "Headquarters", "Regional Office"];

export const EVALUATION_METHODS = [
  { value: "LESRB", label: "LESRB — Lowest Evaluated Substantially Responsive Bid (Goods/Works)" },
  { value: "QCBS", label: "QCBS — Quality & Cost Based Selection (Services/Complex IT)" },
  { value: "LCS", label: "LCS — Least Cost Selection" },
  { value: "Lowest Price", label: "L1 — Lowest Priced Responsive Bid" },
  { value: "Best Value", label: "Best Value for Money" },
];

export const STATUS_META = {
  draft: { label: "Draft", cls: "bg-slate-100 text-slate-600 border-slate-300" },
  published: { label: "Published", cls: "bg-[#E6F5FC] text-[#0072A3] border-[#009EDB]/40" },
  under_evaluation: { label: "Under Evaluation", cls: "bg-amber-50 text-amber-700 border-amber-300" },
  awarded: { label: "Awarded", cls: "bg-emerald-50 text-emerald-700 border-emerald-300" },
  cancelled: { label: "Cancelled", cls: "bg-red-50 text-red-600 border-red-300" },
};

export const AI_MODELS = [
  { value: "gpt-5.4", label: "GPT-5.4 (OpenAI)" },
  { value: "claude-sonnet-4-6", label: "Claude Sonnet 4.6" },
  { value: "claude-sonnet-5", label: "Claude Sonnet 5" },
];

export const AI_MODEL_LABELS = Object.fromEntries(AI_MODELS.map((m) => [m.value, m.label]));

export const fmtMoney = (v, c) =>
  `${c} ${Number(v).toLocaleString(undefined, { maximumFractionDigits: 0 })}`;
